import { render } from "./ProjectEdit.vue?vue&type=template&id=510a2f60"
import script from "./ProjectEdit.vue?vue&type=script&lang=js"
export * from "./ProjectEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__